import { IError, BaseError } from '../error'
import { IApiResponseBase } from './api.types'

export const ERROR_NAME = 'API'

export enum ApiErrorCode {
  'unknown' = 1,
  'axios' = 10001,
}

export class ApiError<R> extends BaseError implements IError {
  public data: (R & IApiResponseBase) | undefined

  constructor(code: number, description: string = '', data?: R) {
    super(ERROR_NAME, code, description, false)
    // @ts-ignore
    this.data = data
  }
}
